import React from 'react';
import { Link } from "react-router-dom";
import { MODALS } from '../../../../config/images';
const ModalRemainingDocuments = ({showModalRemaining, closeModal, seasonsLeft}) => {
    if (!showModalRemaining) return null;

    const seasonsText = seasonsLeft ? 
        `${seasonsLeft.includes(' y ') || seasonsLeft.includes(',') ? '' : ''} ${seasonsLeft.includes(' y ') || seasonsLeft.includes(',') ? '' : ''} ${seasonsLeft}` :
        'para las temporadas activas';

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
            <div className="lg:w-[38%] sm:w-[60%] w-[88%] h-auto bg-white rounded-3xl shadow-lg flex flex-col pb-4  ">
                <div className='flex justify-end'>
                    <button
                        onClick={closeModal}
                        className="px-4 py-2 rounded-md"
                    >
                        <img src={MODALS.CLOSE} alt="cerrar"/>
                    </button>
                </div>
                <div className='flex flex-col items-center justify-between gap-3 p-4 px-8 md:items-start md:flex-row'>
                    <img src={MODALS.WARNING} alt="warning"/>
                    <div className='flex flex-col w-full gap-2'>
                        <p className="text-sm text-justify font-itcdemi">
                            Estimado proveedor,
                            <br></br>
                            <span>
                                {`  
                                ¡Su colaboración es clave para el éxito de esta temporada! Hemos detectado que aún tiene documentos pendientes por subir para completar los requisitos como proveedor de emergencia de TASA en la ${seasonsText}.
                                `}  
                            </span>
                        </p>
                        <p className="text-sm text-justify font-itcdemi">
                            Si necesita ayuda o tiene alguna consulta, no dude en escribirnos a: <span className='break-all'>operacionesdecompra@tasa.com.pe.</span> 
                        </p>
                        <p className='text-sm font-itcbold'>
                            <Link
                                to="/requisitos-de-inicio-de-temporada"
                                className="underline cursor-pointer text-blue "
                            >
                                Revise su documentación pendiente
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ModalRemainingDocuments;